var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.isAdd ? '添加推荐':(_vm.type=='listadd'?'添加推荐':'修改' ),"maskClosable":false,"width":640,"visible":_vm.visible,"confirmLoading":_vm.confirmLoading,"cancelText":'取消',"okText":'确定'},on:{"ok":_vm.addPerson,"cancel":_vm.handleCancel}},[_c('a-form',{attrs:{"layout":"horizontal","form":_vm.form}},[_c('a-form-item',{attrs:{"label":"推荐课程","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[(_vm.type=='update')?_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'name',
					{
					rules: [
						{
						required: true,
						message: '请选择推荐的课程',
						},
					],
					validateTrigger: 'change',
					},
				]),expression:"[\n            'name',\n\t\t\t\t\t{\n\t\t\t\t\trules: [\n\t\t\t\t\t\t{\n\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\tmessage: '请选择推荐的课程',\n\t\t\t\t\t\t},\n\t\t\t\t\t],\n\t\t\t\t\tvalidateTrigger: 'change',\n\t\t\t\t\t},\n\t\t\t\t]"}],staticClass:"form-cell",attrs:{"show-search":"","disabled":true,"option-filter-prop":"children","filter-option":_vm.filterOption,"placeholder":"请选择"},on:{"change":_vm.handleRecommendlist}},_vm._l((_vm.courseList),function(item,index){return _c('a-select-option',{key:index,attrs:{"value":index}},[_vm._v(_vm._s(item.courseName))])}),1):_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'courseId',
					{
					rules: [
						{
						required: true,
						message: '请选择推荐的课程',
						},
					],
					validateTrigger: 'change',
					},
				]),expression:"[\n            'courseId',\n\t\t\t\t\t{\n\t\t\t\t\trules: [\n\t\t\t\t\t\t{\n\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\tmessage: '请选择推荐的课程',\n\t\t\t\t\t\t},\n\t\t\t\t\t],\n\t\t\t\t\tvalidateTrigger: 'change',\n\t\t\t\t\t},\n\t\t\t\t]"}],staticClass:"form-cell",attrs:{"show-search":"","disabled":_vm.type == 'add',"option-filter-prop":"children","filter-option":_vm.filterOption,"placeholder":"请选择"},on:{"change":_vm.handleRecommendlist}},_vm._l((_vm.courseList),function(item,index){return _c('a-select-option',{key:index,attrs:{"value":index}},[_vm._v(_vm._s(item.courseName))])}),1)],1),_c('a-form-item',{attrs:{"label":"推荐理由","labelCol":{ lg: { span: 7 } },"wrapperCol":{ lg: { span: 13 } }}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'intro',
            {
              rules: [
                {
					required: true,
					validator: (rule, value, cbfn) => {
						let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
						let mat = value.match(cnReg)
						let length
						let cnlength
						let enlength
						if(mat){
							cnlength = mat.length*2
							enlength = value.length - mat.length
						}else{
							cnlength = '0'
							enlength = value.length
						}
						length = cnlength + enlength
						if (!value) {
						cbfn('推荐理由不能为空')
						} else if (length > 20) {
						cbfn('仅支持10个汉字或者20个英文')
						} 
						cbfn()
					}
					}
              ],
              validateTrigger: 'change',
            },
          ]),expression:"[\n            'intro',\n            {\n              rules: [\n                {\n\t\t\t\t\trequired: true,\n\t\t\t\t\tvalidator: (rule, value, cbfn) => {\n\t\t\t\t\t\tlet cnReg = /([\\u4e00-\\u9fa5]|[\\u3000-\\u303F]|[\\uFF00-\\uFF60])/g\n\t\t\t\t\t\tlet mat = value.match(cnReg)\n\t\t\t\t\t\tlet length\n\t\t\t\t\t\tlet cnlength\n\t\t\t\t\t\tlet enlength\n\t\t\t\t\t\tif(mat){\n\t\t\t\t\t\t\tcnlength = mat.length*2\n\t\t\t\t\t\t\tenlength = value.length - mat.length\n\t\t\t\t\t\t}else{\n\t\t\t\t\t\t\tcnlength = '0'\n\t\t\t\t\t\t\tenlength = value.length\n\t\t\t\t\t\t}\n\t\t\t\t\t\tlength = cnlength + enlength\n\t\t\t\t\t\tif (!value) {\n\t\t\t\t\t\tcbfn('推荐理由不能为空')\n\t\t\t\t\t\t} else if (length > 20) {\n\t\t\t\t\t\tcbfn('仅支持10个汉字或者20个英文')\n\t\t\t\t\t\t} \n\t\t\t\t\t\tcbfn()\n\t\t\t\t\t}\n\t\t\t\t\t}\n              ],\n              validateTrigger: 'change',\n            },\n          ]"}],attrs:{"type":"text","placeholder":"请输入"},on:{"blur":_vm.validateIntroBlur}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }